// extracted by mini-css-extract-plugin
module.exports =  {"root":"dMDyFv6jV1xhU1Z1d186","label":"hbSVcWkYbd55ToCx1wne"};